import React from 'react';
export function CTASection() {
  return <section className="bg-roi-red px-6 py-20 text-center" data-id="element-16">
      <div className="max-w-2xl mx-auto space-y-8" data-id="element-17">
        <h2 className="text-white text-3xl md:text-4xl font-manrope font-semibold leading-tight" data-id="element-18">
          Ready to See What Your Numbers Are Really Saying?
        </h2>

        <button className="w-full bg-white text-roi-red font-semibold py-5 px-6 rounded-[8px] text-lg hover:bg-gray-100 transition-colors shadow-lg" data-id="element-19">
          Book Your Demo
        </button>
      </div>
    </section>;
}